(function () {
    const votebar = document.getElementById("votebar");

    if (votebar) {
        const answerYes = "I found this page useful.";
        const answerNo = "I did not find this page useful.";

        const votebarVote = document.getElementById("votebar-vote");
        const buttonYes = document.getElementById("votebar-like");
        const buttonNo = document.getElementById("votebar-dislike");
        const buttonClose = document.querySelector(".feedback__form__close.link-btn");
        const formInitial = document.querySelector(".feedback__initial__form");
        const formTextarea = document.querySelector(".feedback__form");

        const inputVote = document.querySelector(".feedback__initial__info");
        const inputTextarea = document.querySelector(".feedback__textarea__info");

        const messageVote = document.getElementById("votebar-sending-vote");
        const messageSending = document.getElementById("votebar-sending-description");
        const messageThanks = document.getElementById("votebar-thankyou");

        const messageTimeout = 2000; // 2 seconds

        // Grab the form's content and POST it to the designated action target
        const submitForm = (form, callback) => {
            const urlEncodedDataPairs = [];

            // Turn the data object into an array of URL-encoded key/value pairs.
            for (let element of form.elements) {
                urlEncodedDataPairs.push(`${encodeURIComponent(element.name)}=${encodeURIComponent(element.value)}`);
            }

            // Combine the pairs into a single string and replace all %-encoded spaces to
            // the '+' character; matches the behavior of browser form submissions.
            const urlEncodedData = urlEncodedDataPairs.join("&").replace(/%20/g, "+");

            let request = new XMLHttpRequest();

            if (callback) {
                request.onreadystatechange = () => {
                    if (request.readyState === 4 && request.status === 200) {
                        callback();
                    }
                };
            }

            request.open("POST", form.getAttribute("action"), true);
            request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
            request.send(urlEncodedData);
        };

        // When clicking either Up/Down, show the feedback form
        [buttonYes, buttonNo].forEach((button) => {
            button.addEventListener("click", (event) => {
                event.preventDefault();
                if (!formTextarea.classList.contains("active")) {
                    formTextarea.classList.add("active");
                }
            });
            button.addEventListener("keyup", (event) => {
                event.preventDefault();
                if (event.key === "Enter" && !formTextarea.classList.contains("active")) {
                    formTextarea.classList.add("active");
                }
            });
        });

        const formInitialCallback = () => {
            setTimeout(() => {
                messageVote.classList.add("hidden");
            }, messageTimeout);
        };

        buttonYes.addEventListener("click", () => {
            if (buttonYes.value !== answerYes) {
                inputVote.value = answerYes;
                inputTextarea.value = answerYes;

                messageVote.classList.remove("hidden");

                submitForm(formInitial, formInitialCallback);
            }
        });

        buttonNo.addEventListener("click", () => {
            if (buttonNo.value !== answerNo) {
                inputVote.value = answerNo;
                inputTextarea.value = answerNo;

                messageVote.classList.remove("hidden");

                submitForm(formInitial, formInitialCallback);
            }
        });

        buttonClose.addEventListener("click", (event) => {
            event.preventDefault();
            formTextarea.classList.remove("active");
        });

        buttonClose.addEventListener("keyup", (event) => {
            if (event.key === "Enter") {
                formTextarea.classList.remove("active");
            }
        });

        const formTextareaCallback = () => {
            messageSending.classList.add("hidden");
            messageThanks.classList.remove("hidden");
        };

        formTextarea.addEventListener("submit", (event) => {
            event.preventDefault();

            votebarVote.hidden = true;

            formTextarea.classList.remove("active");
            messageSending.classList.remove("hidden");

            submitForm(formTextarea, formTextareaCallback);
        });
    }
})();
